import React from "react"
import Layout from "../../components/layout"
import Seo from "../../components/seo"
import MonthArchive from "../../components/newsletter/month-archive"
import { Link, graphql } from 'gatsby'
import NewsletterSummary from "../../components/newsletter/newsletter-summary"
import { convertTimeToAziaZone } from "../../functions/convert-time-to-azia-timezone"
import "../../styles/pc/page/newsletter.scss"
import "../../styles/sp/page/newsletter.scss"

export default function NewsletterDatePost({ data, pageContext }) {
  const { periodStartDate, periodEndDate, thisMonth } = pageContext
  
  const filtered = data.newsletters.edges.filter((data) => {
    const newsletterDate = new Date(new Date(data.node.date).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }))
    const newPeriodStartDate = new Date(new Date(periodStartDate).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }))
    const newPeriodEndDate = new Date(new Date(periodEndDate).toLocaleString('ja-JP', { timeZone: 'Asia/Tokyo' }))
    return newsletterDate >= newPeriodStartDate && newsletterDate <= newPeriodEndDate
  })

  return (
    <Layout>
      <Seo
        type="article"
        title="ニューズレター"
        description=""
        bobyClassName="menu23"
      />
      <div className="wrapper date_list">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/newsletter">Newsletter</Link>　/　<Link to={`/newsletter/${thisMonth.replace(/\./g, '')}`} className="current">{thisMonth}</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Newsletter</span></h2>
              <p className="subtitle"><span>ニューズレター</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
      {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
      <div className="contents_01 detail">
        <div className="contents_in">
          <div className="padding_sp">{/* スマホのみ隙間 */}
            <div className="inner_title">
              <div className="inner_title_in">
                <h5 className="maintitle category_title t_center">
                  <span>{thisMonth}</span>
                </h5>
              </div>
            </div>
            <div className="newsletter_wrapper">
                <div className="newsletter_detail_l">
                  { filtered ?
                    filtered.map(({ node }) => (
                      <NewsletterSummary
                        newslettersId={node.newslettersId}
                        date={convertTimeToAziaZone(node.date,'YYYY年MM月DD日')}
                        title={node.title}
                        body={node.body}
                      />
                    ))
                    :
                    ''
                  }
                </div>
                <p className="newsletter_txt sp_only">ジェイフィール メールマガジンは楽しい会社、元気な会社、良い仲間に恵まれた会社にするための情報が詰まったメールマガジンです。登録はメールアドレスを入力いただくだけ。ぜひご登録ください！</p>
                <div className="newsletter_entry sp_only"><a href="https://ma.j-feel.jp/NZ_inquiry_lp.html">ニューズレターを受け取る</a></div>
              <MonthArchive />
            </div>
            <p className="newsletter_txt pc_only">ジェイフィール メールマガジンは楽しい会社、元気な会社、良い仲間に恵まれた会社にするための情報が詰まったメールマガジンです。登録はメールアドレスを入力いただくだけ。ぜひご登録ください！</p>
            <div className="newsletter_entry pc_only"><a href="https://ma.j-feel.jp/NZ_inquiry_lp.html">ニューズレターを受け取る</a></div>
          </div>{/* padding_sp スマホのみ隙間 */}
        </div>{/* contents_in */}
      </div>{/* /contents */}
      {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
        </div>{/* main */}
        <div className="page_title fixed">
          <div className="right_page_ttl"><span className="vertical">Newsletter - </span><span className="txt">ニューズレター</span></div>
        </div>{/* right page_title */}
      </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query NewsletterFilterByDateQuery {
  newsletters: allMicrocmsNewsletters(
    sort: {fields: [date], order: DESC}
  ) {
    edges {
      node {
        newslettersId
        title
        date
        body
      }
    }
  }
}`
